import { AccordionDetails, AccordionSummary, Typography, Accordion, LinearProgress, Grid, Paper } from "@mui/material";

import { IAnswer, Score } from "../domain/AssistantTypes";
import AssistantService from "../services/AssistantService";
import DataService from "../services/DataService";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { responsiveSpace } from "modules/utils/resposive-style";
// import jsPDF from "jspdf";


const ResultStep = () => {
  const { state } = useLocation();
  const [scores, setScores] = useState<Score[]>([]);
  const [suggestionsList, setSuggestionsList] = useState<string[]>([]);
  // const htmlResultElement = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let answers = state.answers as IAnswer[];

    if (!answers) {
      answers = (new DataService()).getAnswers();
    }
    const assService = new AssistantService();
    setScores(() => assService.getScores(answers));
    setSuggestionsList(() => assService.getSuggestion(answers));
    assService.saveUserResultInServer(answers);
  }, [state]);
  const padding = {
    md: 6,
    xs: 3
  }
  return (
    <Paper elevation={0} sx={{ backgroundColor: 'white', m: 1 }}>
      <Accordion defaultExpanded sx={{ borderRadius: 5, my: 3 }}>
        <AccordionSummary
          sx={{ backgroundColor: 'primary.main', py: 0, display: 'flex', justifyContent: 'center', borderTopLeftRadius: 5, borderTopRightRadius: 5, mx: 0, my: 0 }}
        >
          <Typography color={'white'} textAlign={'center'} py={0} lineHeight={1} >
            Based on your responses, below are the areas of focus to meet your organization's cybersecurity needs.
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: 'white', p: { ...padding }, borderBottomLeftRadius: 5, borderBottomRightRadius: 5 }}>
          <Typography variant="h2" mb={5}>Your Security Maturity Level </Typography>
          {scores && scores.map((score, index) => (
            <div>
              {
                score.degree > 0 ? (
                  <Grid sx={{ mb: 2 }}>
                    <Grid md={3}>
                      <Typography fontWeight={500} color={'text.primary'} >{score.name}</Typography>
                    </Grid>
                    <Grid md={9}>
                      <LinearProgress variant="determinate" value={score.degree} />
                    </Grid>
                  </Grid>)
                  : (<></>)
              }
            </div>
          ))}
        </AccordionDetails>
      </Accordion >
      <Accordion sx={{ borderRadius: 5, my: 3 }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
          sx={{ backgroundColor: 'primary.main', py: 0, borderTopLeftRadius: 5, borderTopRightRadius: 5 }}
        >
          <Typography color={'white'}  >See Top Recommendations</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: 'white', p: { ...padding }, borderBottomLeftRadius: 5, borderBottomRightRadius: 5 }}>

          {suggestionsList && suggestionsList.slice(0, 4).map((suggestion, index) => (
            <div key={index}>
              <Typography mb={4}>{suggestion}</Typography>
            </div>
          ))}
        </AccordionDetails>
      </Accordion>
      <Accordion sx={{ borderRadius: 5, my: 3 }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
          sx={{ backgroundColor: 'primary.main', py: 0, borderTopLeftRadius: 5, borderTopRightRadius: 5 }}
        >
          <Typography color={'white'} >See All Recommendations</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: 'white', p: { ...padding }, borderBottomLeftRadius: 5, borderBottomRightRadius: 5 }}>
          <Typography>
            {suggestionsList && suggestionsList.slice(5).map(suggestion => (
              <Typography mb={4}>{suggestion}</Typography>
            ))}
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Paper>
  )
}

export default ResultStep;